import React, { Component } from "react";
import { connect } from "react-redux";
import { Chart } from "primereact/chart";
import { CSVLink } from "react-csv";
import { KEY_PERFORMANCE_BY_CAMPAIGN as header } from "../../Utils/StaticData/DashboardHeader";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import SkipNextIcon from "@material-ui/icons/SkipNext";
class PerformanceByCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //applicationStatusData: { statusLabels: [], statusValues: [] },
      applicationCategoryData: { categoryLabels: [[]], categoryValues: [[]] },
      //   pieChartStatusData: this.props.pieKeyPerformanceByAgent,
      barChartCategoryData: this.props.KeyPerformanceByCampaign,
      csvData: this.props.keyPerformanceByCampaignExport,
      PageIndex: 0,
      MaxPageIndex: 0,
    };
  }
  setData = (pieData, appData, Label, Value, type) => {
    let labelArray = [];
    let valueArray = [];
    // let dropOptions = [];
    if (type === "Category") {
      //loop to extract labels and values for chart from response(json)
      if (pieData !== undefined) {
        for (let i = 0; i < pieData?.labelList?.length; i++) {
          const label = pieData.labelList[i];
          const value = pieData.valueList[i];
          labelArray.push(label);
          valueArray.push(value);
        }
      }
      labelArray.push("");
      valueArray.push("");
      let divideBY =
        labelArray.length / 20 + (labelArray.length % 20 > 0 ? 1 : 0);
      let j = 0,
        k = 1;
      if (divideBY > 0) {
        let labelsets = [];
        let datasets = [];
        for (let i = 1; i <= Math.floor(divideBY); i++) {
          let arr = "";
          if (i === divideBY) {
            arr = labelArray.slice(20 * j);
          } else {
            arr = labelArray.slice(20 * j, 20 * k);
          }
          labelsets[i - 1] = arr;
          j = j + 1;
          k = k + 1;
        }
        j = 0;
        k = 1;
        for (let i = 1; i <= Math.floor(divideBY); i++) {
          let arr = "";
          if (i === divideBY) {
            arr = valueArray.slice(20 * j);
          } else {
            arr = valueArray.slice(20 * j, 20 * k);
          }
          datasets[i - 1] = arr;
          j = j + 1;
          k = k + 1;
        }
        let max = Math.floor(divideBY);
        this.setState({
          [appData]: {
            [Label]: labelsets,
            [Value]: datasets,
          },
          PageIndex: 0,
          MaxPageIndex: max,
        });
      }
    }
  };
  componentWillReceiveProps(nextProps) {
    if (
      this.props.KeyPerformanceByCampaign !== nextProps.KeyPerformanceByCampaign
    ) {
      this.setData(
        nextProps.KeyPerformanceByCampaign,
        "applicationCategoryData",
        "categoryLabels",
        "categoryValues",
        "Category"
      );
    }
    if (
      this.props.keyPerformanceByCampaignExport !==
      nextProps.keyPerformanceByCampaignExport
    ) {
      this.setState({
        ...this.state,
        csvData: nextProps.keyPerformanceByCampaignExport,
      });
    }
  }
  componentDidMount() {
    const { barChartCategoryData } = this.state;
    this.setData(
      barChartCategoryData,
      "applicationCategoryData",
      "categoryLabels",
      "categoryValues",
      "Category"
    );
  }
  getTooltip = (tooltipItem, data1) => {
    let index = tooltipItem.index;
    let label = data1.labels[index];
    let value = data1.datasets[0].data[index];
    if (label === "Cancelled") label = "Application is cancelled by plan";
    if (label === "Denied eligibillity")
      label = "Application has been deemed not eligible by plan";
    if (label === "Duplicate application")
      label =
        "A duplicate application exists and currently being reviewed by plan";
    if (label === "Eligibility review")
      label = "The application eligibility is being reviewed";
    if (label === "Incomplete")
      label =
        "Application has incomplete information that is being reviewed by the plan";
    if (label === "Being Submitted to CMS")
      label =
        "The application is currently being submitted to CMS for approval";
    if (label === "RFI") label = "RFI has been initiated by plan";
    return label + " : " + value + " ";
  };
  PaginationHandlerInitial = (e) => {
    if (this.state.MaxPageIndex > 1 && this.state.PageIndex > 0) {
      this.setState({ PageIndex: 0 });
    }
  };
  PaginationHandlerEnd = (e) => {
    if (
      this.state.MaxPageIndex > 1 &&
      this.state.PageIndex !== this.state.MaxPageIndex - 1
    ) {
      this.setState({ PageIndex: this.state.MaxPageIndex - 1 });
    }
  };
  PaginationHandlerBack = (e) => {
    if (this.state.MaxPageIndex > 1 && this.state.PageIndex > 0) {
      this.setState({ PageIndex: this.state.PageIndex - 1 });
    }
  };
  PaginationHandlerForward = (e) => {
    if (
      this.state.MaxPageIndex > 1 &&
      this.state.PageIndex < this.state.MaxPageIndex - 1
    ) {
      this.setState({ PageIndex: this.state.PageIndex + 1 });
    }
  };
  render() {
    const { categoryLabels, categoryValues } =
      this.state.applicationCategoryData;
    const categoryOptions = {
      responsive: true,
      maintainAspectRatio: true,
      title: {
        display: false,
        text: "Enrollments",
      },

      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                display: false,
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              barPercentage: 1,
              categoryPercentage: 1,
            },
          ],
        },
      },

      onClick: function clickHandler(evt, element) {
        // const x=document.getElementById("bar")
        // const points = x.getElementsAtEventForMode(evt, 'nearest', { intersect: true }, true);
        // if (points.length) {
        //     const firstPoint = points[0];
        //     const label = x.data.labels[firstPoint.index];
        //     const value = x.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
        //     console.log("label",label)
        //     console.log("value",value)
        // }
      },
      scales: {
        y: {
          ticks:{
            precision:0
          },
          title: {
            display: true,
            text: "No. Of  Prospects",
          },
        },
        x: {
          ticks: {
            display: this.props.showXaxis ? true : false,
            //omitXLabels: true,
          },
          // min:0,
          // max:10
        },
      },
      plugins: {
        legend: {
          display: false,
          position: "top",
          align: "center",
        },
      },
    };
    const categoryData = {
      labels: categoryLabels[this.state.PageIndex],
      datasets: [
        {
          label: "No. of  Prospects",
          data: categoryValues[this.state.PageIndex],
          barThickness: 15,
          barValueSpacing: 0.5, // doesn't work; find another way
          barDatasetSpacing: 0.5,
          barPercentage: 0.5,
          maxBarThickness: 20,
          minBarThickness: 2,
          backgroundColor: [
          "#b2d103",
          "#03d11f",
          "#03d1d1",
          "#707eea",
          "#f089a7",
          "#f1c12f",
          "#b2d103",
          "#03d11f",
          "#03d1d1",
          "#707eea",
          "#f089a7",
          "#f1c12f"
          ],
          // hoverBackgroundColor: [
          //   "#b9edc4",
          //   "#abede2",
          //   "#5a8f86",
          //   "#56609c",
          //   "#529651",
          //   "#a68465",
          //   "#996077",
          //   "#609099",
          // ],
          borderWidth: 1,
        },
      ],
    };
    // const moveChart={
    //   id:"moveChart1",
    //   afterDraw(chart,args,choption){
    //     console.log("chart22",chart)
    //   }
    // }
    return (
      <>
      
        {/* {console.log("ppp",this.props.KeyPerformanceByCampaign)} */}
        {this.props.showExport &&
        this.props.KeyPerformanceByCampaign?.labelList?.length > 0 ? (
          <CSVLink
            data={this.state.csvData}
            filename={"KeyPerformanceByCampaign.csv"}
            className="btn btn-primary csv-export-btn"
            headers={header}
          >
            Export
          </CSVLink>
        ) : null}
        {this.props.isModal ?
        <div>
          <div class="d-flex flex-row justify-content-center">
            <div
              onClick={this.PaginationHandlerInitial}
              className={this.state.PageIndex === 0 ? "pagination-disable" : ""}
            >
              <SkipPreviousIcon />
            </div>
            <div
              onClick={this.PaginationHandlerBack}
              className={
                this.state.PageIndex === 0
                  ? "pagination-disable pagination-padding"
                  : "pagination-padding"
              }
            >
              <ArrowLeftIcon />
            </div>
            <div
              onClick={this.PaginationHandlerForward}
              className={
                this.state.MaxPageIndex <= 1 ||
                this.state.PageIndex === this.state.MaxPageIndex - 1
                  ? "pagination-disable"
                  : ""
              }
            >
              <ArrowRightIcon />
            </div>
            <div
              onClick={this.PaginationHandlerEnd}
              className={
                this.state.MaxPageIndex <= 1 ||
                this.state.PageIndex === this.state.MaxPageIndex - 1
                  ? "pagination-disable"
                  : ""
              }
            >
              <SkipNextIcon />
            </div>
          </div>
          <Chart
            type="bar"
            //  id="categorychart1"
            data={categoryData}
            // width={pieWidth}
            // width={"700px"}
            //  height={"300px"}
            // min-height={"257px"}
            options={categoryOptions}
            // plugins={moveChart}
            // height={pieHeight}
          />
        </div>
        :
        <Chart
            type="bar"
            //  id="categorychart1"
            data={categoryData}
            // width={pieWidth}
            // width={"700px"}
            //  height={"300px"}
            // min-height={"257px"}
            options={categoryOptions}
            // plugins={moveChart}
            // height={pieHeight}
          />
            }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //KeyPerformanceByCampaign:state.webApp.KeyPerformanceByCampaign,
    keyPerformanceByCampaignExport: state.export.keyPerformanceByCampaignExport,
  };
};
const mapDispatchToProps = {
  //keyPerformanceByAgent,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceByCampaign);
